import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import sidebarNavigationItemStyles from './sidebarNavigationItemStyles'

const SidebarNavigationItem = styled(NavLink)`
	${sidebarNavigationItemStyles}
`

export default SidebarNavigationItem